import React, {Component} from 'react';
import {
	Button,
	Link,
	Select,
	SelectItem,
	Slider,
	Tabs,
	Tab,
} from 'carbon-components-react';
import { Renew16 } from '@carbon/icons-react';

import PropertyComponent from '../../components/PropertyComponent';
import CCSlider from '../../components/CCSlider';
import ParameterSlider from '../../components/ParameterSlider';
import ParameterToggle from '../../components/ParameterToggle';
import { IndexedParameterSelect, IndexedParameterValue } from '../../components/IndexedParameterSelect';
import LoggingToggle from '../../components/LoggingToggle';
import MidiDevicesDialogWrapper from '../../components/MidiDevicesDialogWrapper';
import NoteDivisionParameterSelect from '../../components/NoteDivisionParameterSelect';
import DevicePropertyButton from '../../components/DevicePropertyButton';
import DevicePropertySelect from '../../components/DevicePropertySelect';
import DevicePropertyToggle from '../../components/DevicePropertyToggle';
import PresetTable from '../../components/PresetTable';
import {
	FirmwareVersionField,
	ErrorCodeField,
	PSUVoltageField,
	MidiChannelSelector
} from '../../components/ConfigSettings';

import * as midi from '../../js/rpl_midi.js';

midi.setProductId(0x01, 0x03, 'Bitmap');
midi.initialize();

class ExprDestinationSelector extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return (
	  				<Select value={this.state.value} labelText="" defaultValue="Dest..." onChange={this.handleChange}>
					  <SelectItem value="0" text="Off"/>
					  <SelectItem value="1" text="Mix"/>
					  <SelectItem value="2" text="Crush"/>
					  <SelectItem value="3" text="Freq"/>
					  <SelectItem value="4" text="Mod Rate"/>
					  <SelectItem value="5" text="Mod Depth"/>
					  <SelectItem value="6" text="Env Amount"/>
					  <SelectItem value="7" text="Drive"/>
					  <SelectItem value="8" text="Filter Freq"/>
					  <SelectItem value="9" text="Filter Res"/>
	  				</Select>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setIndexedParameterValue(this.propId, newValue);
	}

	setValue(x) {
		this.setState({value : x});
	}
}

class ExprSlider extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return <Slider min="0" max="100" step="0.1" stepMultiplier="40" labelText={this.labelText} onChange={this.handleChange} value={this.state.value} disabled={this.state.disabled} hideTextInput="1"/>
	}

	handleChange(props) {
		var newValue = Number(props.value);
		this.setState({value: newValue});
		midi.setParameterValue(this.propId, newValue / 100);
	}

	handleControlChange(ccNum, ccValue) {
		this.setValue(ccValue / 127);
	}

	setValue(x) {
		// Because the property ID has bit 0x2000 set, rpl_midi does not
		// scale the value
		this.setState({value : 100 * x / 8388608.0});
	}
}

class ExprDestination extends React.Component {
	constructor(props) {
		super(props);

		this.destPropId = props.destPropId;
		this.minPropId  = props.minPropId;
		this.maxPropId  = props.maxPropId;
	}

	render() {
		return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-4 bx--col-md-5 bx--col-lg-4">
	  				<ExprDestinationSelector propId={this.destPropId}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ExprSlider labelText="" propId={this.minPropId}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ExprSlider labelText="" propId={this.maxPropId}/>
	  			  </div>
	  			</div>
		);
	}
}

class ExprDestinations extends React.Component {

	createDestinations() {
		var children = [];

		for (var i = 0; i < 6; i++) {
			children.push(<ExprDestination
							destPropId={midi.PROPERTY_EXPR_DEST_1 + 3*i}
							minPropId={midi.PROPERTY_EXPR_MIN_1 + 3*i}
							maxPropId={midi.PROPERTY_EXPR_MAX_1 + 3*i}
						  />
						);
		}

		return children;
	}

	render() {
		return (
			<div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-4 bx--col-md-5 bx--col-lg-4">
	  				Destination
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				Heel (Min)
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				Toe (Max)
	  			  </div>
	  			</div>
				{this.createDestinations()}
			</div>
		);
	}
}

class RemoteModeSelector extends PropertyComponent {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	createButtonAssignments() {
		if (this.state.value == 0) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 1<br/>DblT: Live<br/>Hold: Save</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 2<br/>DblT: Live<br/>Hold: Save</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 3<br/>DblT: Live<br/>Hold: Save</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 4<br/>DblT: Live<br/>Hold: Save</div>
	  			</div>
			);
		} else if (this.state.value == 1) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset<br/>&nbsp;<br/>&nbsp;</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">On<br/>&nbsp;<br/>Hold: Momentary</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Mod hold<br/>&nbsp;<br/>&nbsp;</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Tap<br/>&nbsp;<br/>&nbsp;</div>
	  			</div>
			);
		}
	}

	render() {
		return (
			<div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <Select labelText="Remote Mode" value={this.state.value} onChange={this.handleChange}>
	  				<SelectItem text="Mode 1 - Presets 1-4" value="0"/>
	  				<SelectItem text="Mode 2 - Preset | On | LFO Hold | Tap" value="1"/>
	  			  </Select>
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">A</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">B</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">C</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">D</div>
	  			</div>
				{this.createButtonAssignments()}
			</div>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setDeviceProperty(this.propId, [newValue]);
	}

	setValue(x) {
		this.setState({value : x });
	}
}

const props = {
  exprSlider: {
	  hideTextInput: 1,
	  min: 0,
	  max: 100,
	  step: 0.1,
	  stepMultiplier: 40,
	  labelText: null,
  },
  tabs: {
    selected: 0,
    triggerHref: '#',
    role: 'navigation',
  },
  tab: {
    href: '#',
    role: 'presentation',
    tabIndex: 0,
  },
};

const EditorPage = () => {
  return (
    <div className="bx--grid bx--grid--full-width landing-page">
      <div className="bx--row editor-page__status">
        <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-4">
	  		Status:&nbsp;
	  	    <span id="device-status"></span>
	    </div>
        <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">
	      <Button
	        className="editor-page__statusbtn"
	        disabled={false}
	        hasIconOnly={false}
	        iconDescription="Refresh"
	        kind="primary"
	        onClick={function noRefCheck(){midi.findMIDIDevice()}}
	        onFocus={function noRefCheck(){}}
	        renderIcon={Renew16}
	        size="default"
	        tabIndex={0}
	        tooltipAlignment="center"
	        tooltipPosition="bottom"
	        type="button"
	      >Refresh</Button>
	    </div>
      </div>
      <div className="bx--row landing-page__r2">
	    <div className="bx--col bx--no-gutter">
	      <Tabs {...props.tabs}>
	        <Tab {...props.tab} label="Edit">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mix" propId={0} ccNum={12}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Crush" propId={1} ccNum={13}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Freq" propId={2} ccNum={14}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Drive" propId={6} ccNum={23}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Filter Cutoff" propId={8} ccNum={21}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Filter Resonance" propId={9} ccNum={22}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mod Rate" propId={3} ccNum={16}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mod Depth" propId={4} ccNum={15}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Mod Wave" propId={8203} ccNum={102}>
	  				  <IndexedParameterValue value="0" text="Triangle"/>
	  				  <IndexedParameterValue value="1" text="Square"/>
	  				  <IndexedParameterValue value="2" text="Random"/>
	  				  <IndexedParameterValue value="3" text="Wavefolder"/>
	  				  <IndexedParameterValue value="4" text="Window"/>
	  				  <IndexedParameterValue value="5" text="Waveshaper"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<NoteDivisionParameterSelect labelText="Mod Note Div" range="slow" propId={8202} ccNum={108}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Env Depth" propId={5} ccNum={20}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<IndexedParameterSelect labelText="Mod Dest" propId={8204} ccNum={103}>
	  				  <IndexedParameterValue value="0" text="Freq"/>
	  				  <IndexedParameterValue value="1" text="Filter"/>
	  				  <IndexedParameterValue value="2" text="Mix"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Output Level (v2.1+, AGC at min.)" propId={7} ccNum={24}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<IndexedParameterSelect labelText="Env Dest" propId={8205} ccNum={104}>
	  				  <IndexedParameterValue value="0" text="Off"/>
	  				  <IndexedParameterValue value="1" text="Filter"/>
	  				  <IndexedParameterValue value="2" text="Mix"/>
	  				  <IndexedParameterValue value="3" text="Mix - "/>
	  				  <IndexedParameterValue value="4" text="Freq -"/>
	  				  <IndexedParameterValue value="5" text="Freq +"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Drive Type (v2.1+)" propId={8206} ccNum={111}>
	  				  <IndexedParameterValue value="0" text="Hard Clipping"/>
	  				  <IndexedParameterValue value="1" text="Distortion 1"/>
	  				  <IndexedParameterValue value="2" text="Distortion 2"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Filter Range (v2.1+)" propId={8208} ccNum={113}>
	  				  <IndexedParameterValue value="0" text="Normal"/>
	  				  <IndexedParameterValue value="1" text="Full"/>
	  				  <IndexedParameterValue value="2" text="Relative"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Anti-Aliasing (2.1+)" propId={8207} ccNum={112}>
	  				  <IndexedParameterValue value="0" text="Off"/>
	  				  <IndexedParameterValue value="1" text="On"/>
	  				  <IndexedParameterValue value="2" text="Adjustable Filter"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			</div>
			  </div>
	        </Tab>

	        <Tab {...props.tab} label="Ctrl Port">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-ctrl">
	  			Click Save button at bottom of page to save configuration.
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-2 bx--col-md-4 bx--col-lg-8">
	  				<DevicePropertySelect labelText="CTRL Port Mode" propId={midi.PROPERTY_CTRL_MODE}>
	  				  <SelectItem text="Off" value="0"/>
	  				  <SelectItem text="Expression" value="1"/>
	  				  <SelectItem text="Tap Tempo" value="2"/>
	  				  <SelectItem text="Remote" value="3"/>
	  				  <SelectItem text="MIDI In (Tip Active)" value="4"/>
	  				</DevicePropertySelect>
	  			  </div>
  	  			  <div className="bx--col-sm-2 bx--col-md-4 bx--col-lg-8">
	  				<CCSlider labelText="Expression Pedal Position" ccNum={4}/>
	  			  </div>
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <h1>Expression</h1>
	  			</div>
	  			<ExprDestinations/>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <h1>Remote</h1>
	  			</div>
	  			<RemoteModeSelector propId={midi.PROPERTY_REMOTE_BANK}/>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div class="bx--btn-set">
	  				<DevicePropertyButton kind="secondary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[0]} refreshProps={true}>
	  				  Revert
	  				</DevicePropertyButton>
	  				<DevicePropertyButton kind="primary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[1]}>
	  				  Save
	  				</DevicePropertyButton>
	  			  </div>
	  			</div>
	  		  </div>
	        </Tab>

	        <Tab {...props.tab} label="Preset">
	  		  <PresetTable numProgs={127} liveProg={128} allowRename={false}/>
	        </Tab>

	        <Tab {...props.tab} label="Config">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-config">
	  			<FirmwareVersionField propId={midi.PROPERTY_FIRMWARE_VERSION}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			{/* <PSUVoltageField propId={midi.PROPERTY_PSU_VOLTAGE}/> */}
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			<ErrorCodeField propId={midi.PROPERTY_ERROR_CODE}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="AUX Switch" propId={midi.PROPERTY_AUX_SWITCH_MODE}>
	  			    <SelectItem text="Tap" value="0"/>
	  			    <SelectItem text="Preset" value="1"/>
	  			    <SelectItem text="Preset Shift" value="2"/>
	  			    <SelectItem text="Modulation On/Off" value="3"/>
	  			    <SelectItem text="LFO Hold" value="4"/>
	  			    <SelectItem text="LFO Hold On/Off" value="5"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Input/Output Configuration" propId={midi.PROPERTY_IO_CONFIG}>
	  			    <SelectItem text="Mono In / Mono Out" value="0"/>
	  			    <SelectItem text="Mono In / Stereo Out" value="1"/>
	  			    <SelectItem text="Stereo In / Stereo Out" value="2"/>
	  			  </DevicePropertySelect>
	  			</div>
	  {/*
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Bypass Mode" propId={midi.PROPERTY_BYPASS_MODE}>
	  			    <SelectItem text="DSP" value="2"/>
	  			    <SelectItem text="Analog" value="1"/>
	  			    <SelectItem text="Analog + FX Level" value="4"/>
	  			    <SelectItem text="Kill Dry" value="3"/>
	  			  </DevicePropertySelect>
	  			</div>
		*/}
	  			<div className="bx--row editor-page__tab-config">
	  			  <MidiChannelSelector propId={midi.PROPERTY_MIDI_CHANNEL}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  				<DevicePropertyToggle labelText="Receive MIDI Clock" labelA="Off" labelB="On" propId={midi.PROPERTY_RECEIVE_MIDI_CLOCK}/>
	  			</div>
	  		  </div>
	        </Tab>
	        <Tab {...props.tab} label="Help">
			  <h3>Resources</h3>
  				<Link href="https://redpandalab.freshdesk.com/support/home">Knowledge Base</Link><br/>
				<Link href="http://www.redpandalab.com/downloads/">User Manuals and Firmware Updates</Link><br/>
				<Link href="http://www.redpandalab.com/contact/">Contact Us</Link><br/>

	  		  <h3>Expression Pedal</h3>
  				<p>To assign the expression pedal to any combination of knobs:
  				<ol>
  				  <li>1. Hold the right footswitch while pluggin in the expression pedal (right LED will blink orange 3x).</li>
  				  <li>2. Move expression pedal to the heel down position.</li>
  				  <li>3. Adjust knobs for the desired sound.</li>
  				  <li>4. Move expression pedal to the toe down position.</li>
  				  <li>5. Adjust knobs for the desired sound.</li>
  				  <li>6. Hold the right footswitch for 2 seconds to save (right LED will blink green).</li>
  				</ol>
  				</p>
	
  			  <h3>Limitations</h3>
				<ul>
  	  		  	  <li>The web editor does not reflect changes made by another MIDI device.
  	  			      Hit Refresh to update.</li>
				</ul>

			  <h3>Troubleshooting</h3>
	  		  <div className="bx--row editor-page__tab-help">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  		        <MidiDevicesDialogWrapper/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  		        <LoggingToggle/>
	  			  </div>
	  		  </div>
	
	        </Tab>
	      </Tabs>
	    </div>
      </div>
      <div className="bx--row landing-page__r3">
      </div>
    </div>
  );
};

export default EditorPage;

